import {Component, Input, OnInit} from '@angular/core';
import {BooKingservice} from "../booking.service";

@Component({
  selector: 'app-count-down',
  templateUrl: './count-down.component.html',
  styleUrls: ['./count-down.component.css']
})
export class CountDownComponent implements OnInit {

  @Input() sessionExpirationTime:number;
  timerMinutes:number =15;
  timerSecondes:number =0;
  currenteventUrl:string;

  constructor(private bookingservice :BooKingservice) {

  }



  formatTimer(item) {
    if(item<10)
      return '0'+item;
    return item;
  }

  ngOnInit() {
    this.currenteventUrl = this.bookingservice.retrieve('currenteventUrl');
    let me = this;
    setInterval(function () {
      if(me.sessionExpirationTime > 0) {
        me.timerMinutes = me.formatTimer(Math.floor(me.sessionExpirationTime/60000));
        me.timerSecondes = me.formatTimer((me.sessionExpirationTime %60000)/1000);
        me.sessionExpirationTime = me.sessionExpirationTime - 1000;
        me.bookingservice.store('sessionExpirationTime',me.sessionExpirationTime);
      }
      else {

      }
    },1000);

  }


}
